import createClient from '../../apolloClient';
import MUTATION_UPDATE_USER from '../../mutation/updateUser';

const handleUpdateUser = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_UPDATE_USER,
    variables,
  });
  const { updateUser } = result?.data || {};
  return updateUser;
};

export default handleUpdateUser;
